import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as SharedActions from '../actions/shared.actions';
import { SharedEntity } from '../models/shared.models';

export const SHARED_FEATURE_KEY = 'shared';

export interface State extends EntityState<SharedEntity> {
  selectedId?: string | number; // which Shared record has been selected
  loaded: boolean; // has the Shared list been loaded
}

export interface SharedPartialState {
  readonly [SHARED_FEATURE_KEY]: State;
}

export const sharedAdapter: EntityAdapter<SharedEntity> =
  createEntityAdapter<SharedEntity>();

export const initialState: State = sharedAdapter.getInitialState({
  loaded: false
});

const sharedReducer = createReducer(
  initialState,
  on(SharedActions.loadUserSessionSuccess, (state, { session }) => {
    return sharedAdapter.upsertOne(session, { ...state, loaded: true });
  }),
  on(SharedActions.loadUserSessionFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(SharedActions.loadSiteWideUserSessionSuccess, (state, { session }) => {
    return sharedAdapter.upsertOne(session, { ...state, loaded: true });
  }),
  on(SharedActions.loadSiteWideUserSessionFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return sharedReducer(state, action);
}
